/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * Per-publication availability status derived from date columns.
 *
 * A pure function of ``available_ranges``, ``published_at``, ``accessible_from``,
 * ``first_available_from`` and ``NOW()``.
 */
export type AvailabilityStatus = typeof AvailabilityStatus[keyof typeof AvailabilityStatus];


export const AvailabilityStatus = {
  coming_soon: 'coming_soon',
  early_access: 'early_access',
  new_release: 'new_release',
  recently_added: 'recently_added',
  leaving_soon: 'leaving_soon',
  available: 'available',
  unavailable: 'unavailable',
} as const;
